import './sentry';
import './tracing';
import ReactDOM from 'react-dom/client';
import './main.css';
import { setAppHeight } from '@ordr-as/umami-css/lib/js/utilities';
import App from './App';
import config from './config';
import { cleanUpSoftpayCookies } from './utils/softpay/softpayCookie';
import { Userpilot } from 'userpilot';
import { isAdyenDevice } from './utils/isAdyenDevice';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(<App />);

setAppHeight();

if (!['local', 'localQa', 'localProd'].includes(config.env) && !isAdyenDevice()) {
  const userpilotToken = config.env === 'prod' ? 'NX-f4b682c9' : 'STG-NX-f4b682c9';
  Userpilot.initialize(userpilotToken);
}

cleanUpSoftpayCookies();
